import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// import {DocumentUploadComponent} from './document-upload/document-upload.component';
import {DocumentIssueComponent} from './document-issue/document-issue.component';


export const documentRoutes: Routes = [
  {
    path: 'document',
    data: {
      'expectedRoles': ['Accountant', 'Operation', 'IT']
    },
    children: [
      // {
      //   path: 'upload',
      //   component: DocumentUploadComponent
      // },
      {
        path: 'issue',
        component: DocumentIssueComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(documentRoutes)],
  exports: [RouterModule]
})
export class DocumentRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-routing.module.ts